/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quarter: NonNullable<unknown> }} Partner_Payout_Total_ForInputs */



/**
* | output |
* | --- |
* | "Payable · {quarter}" |
*
* @param {Partner_Payout_Total_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_total_for = /** @type {((inputs: Partner_Payout_Total_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Total_ForInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Auszahlbar · ${i?.quarter}`)
	return /** @type {LocalizedString} */ (`Payable · ${i?.quarter}`)
});